export default __webpack_public_path__ + "static/media/BarGraph.1154c7c6.svg";